import { setFile } from './file';
import { subscribeToChannel } from './pusher';
import { createStandardAction } from 'typesafe-actions';
var ActionTypes = {
  DOCUMENT_DELETE_REQUEST: 'DOCUMENT_DELETE_REQUEST',
  DOCUMENT_DELETE_SUCCESS: 'DOCUMENT_DELETE_SUCCESS',
  SET_DOCUMENT_UPLOAD_START_TIME: 'SET_DOCUMENT_UPLOAD_START_TIME'
};
export var setDocUploadStartTime = createStandardAction(ActionTypes.SET_DOCUMENT_UPLOAD_START_TIME)();
export var createDocumentGdrive = function createDocumentGdrive() {
  return function (dispatch, getState, _ref) {
    var gapi = _ref.gapi;
    var _getState = getState(),
      site = _getState.site,
      upload = _getState.app.upload;
    gapi.openDocumentPicker(site, upload).then(function (data) {
      return Promise.resolve(data.docs[0]);
    }).then(function (gdriveDocument) {
      gapi.downloadDocx(gdriveDocument.id, site).then(function (documentData) {
        dispatch(setFile(documentData.file));
        dispatch(subscribeToChannel());
      });
    });
  };
};